import Vue from 'vue';
import VueI18n from 'vue-i18n'
import langs from './langs'

var navigatorStr = (
    navigator.language || navigator.browserLanguage
).toLowerCase();

let locale = ''
if (navigatorStr.indexOf("zh") >= 0) {
    locale = "zh"
} else if (navigatorStr.indexOf("ja") !== -1) {
    locale = "ja";
} else {
    locale = "en";
}

Vue.use(VueI18n)
const i18n = new VueI18n({
    locale: locale,
    messages: langs
})

export default i18n